<template lang="pug">
v-snackbar(
  bottom
  right
  :timeout='3000'
  :color='color'
  @click='$emit(`input`, false)'
  v-model='isShow'
)
  v-icon.mr-2(dark v-if='icon') {{ icon }}
  span(v-html='content')
  v-spacer
</template>

<script>
export default {
  name: 'Snackbar',
  data () {
    return {
      isShow: false,
      content: '',
      color: '',
      icon: '',
    }
  },
  methods: {
    show (_, color = '', icon = '') {
      this.content = _
      this.color = color
      this.icon = icon
      this.isShow = true
    },
  },
}
</script>
